export default __webpack_public_path__ + "static/hetzner_community_5-67ca1f1035825f689f35092a8a1f7cb1.jpg";